/* @flow strict */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';
import _ from 'lodash';
import IntegrationsPreviewModal from '/client/src/pages/Events/detail/codes/previewModal';
import IntegrationsCalendarThemeModal from '/client/src/pages/Integrations/calendar/themeModal';

import './styles.scss';

type PropsType = {
  switcherChecked?: boolean,
  switcherCallback?: () => void,
  switcherLabel?: string,
  customize?: any,
  customCustomizeContent?: any,
  switcher?: any,
  title?: string,
  content?: any,
  noContent?: boolean,
  extraContent?: any,
  imageClass?: string,
  textAreaWrapClassList?: string,
  reason: string,
  reasonOptions?: any,
  eventDetail?: {},
  calendarTheme?: string,
  setCalendarTheme?: (string) => void,
  additionalContent?: any,
  handleTogglePreviewModal?: (boolean) => void,
  handleToggleThemeModal?: (boolean) => void
};

const CodeCard = (props: PropsType): React.Element<'div'> => {
  const randomIndex = _.random(0, Date.now());
  const [isOpenPreview, handleTogglePreviewModal] = React.useState(false);
  const [isOpenTheme, handleToggleThemeModal] = React.useState(false);

  const Cc = props.customCustomizeContent;
  const { calendarTheme, setCalendarTheme, additionalContent, noContent = false } = props;

  return (
    <div className="preview-codes">
      <div className="panel panel-preview">
        <div className="panel-heading">
          <div className="panel-title">
            {props.switcher ? (
              <Switcher
                className="form-switcher-sm pull-left"
                id={`CodeCardSwitcher-${randomIndex}`}
                index={`CodeCardSwitcher-${randomIndex}`}
                checked={props.switcherChecked}
                // eslint-disable-next-line
                onCallback={props.switcherCallback}
                label={props.switcherLabel}
              />
            ) : (
              <span className="text">{props.title}</span>
            )}
          </div>

          <div className="pull-right">
            {props.customize && (
              <span
                className={`${props.customCustomizeContent ? 'preview-link-customCustomizeContent' : ''} preview-link`}
                style={{ right: '60px' }}
                onClick={(): any => {
                  if (props.handleToggleThemeModal) {
                    props.handleToggleThemeModal(true);
                  } else handleToggleThemeModal(true);
                  }
                }
              >
                {props.customCustomizeContent ?
                  <>{props.customCustomizeContent}</> :
                  <i className="icon icon-theme" />
                }
              </span>
            )}

            <span
              className="preview-link"
              onClick={(): any => {
                if (props.handleTogglePreviewModal) {
                  props.handleTogglePreviewModal(true);
                } else handleTogglePreviewModal(true);
                }
              }
            >
              <i className="icon icon-eye" />
            </span>
          </div>
        </div>

        <div className="panel-body">
          <div className="input-group clearfix">
            <span className="input-group-addon">
              <i className="icon icon-code" />
            </span>

            {props.extraContent ? props.extraContent : null}
            {!noContent &&
                <div className={`form-group SimpleInput ${props.textAreaWrapClassList || ''}`}>
                <textarea
                  rows="5"
                  className="form-control"
                  readOnly
                  value={props.content ? props.content : ''}
                />
              </div>
            }
            <div
              className={`input-group-addon preview-item ${props.imageClass}`}
            />
          </div>
          {additionalContent}
        </div>
      </div>

      {isOpenPreview ?
        <IntegrationsPreviewModal
          isOpen={isOpenPreview}
          handleToggleModal={handleTogglePreviewModal}
          reason={props.reason}
          reasonOptions={props.reasonOptions}
          eventDetail={props.eventDetail}
        /> : null}
        {isOpenTheme ?
          <IntegrationsCalendarThemeModal
            isOpen={isOpenTheme}
            calendarTheme={calendarTheme}
            setCalendarTheme={setCalendarTheme}
            handleToggleModal={handleToggleThemeModal}
          /> : null}
    </div>
  );
};

export default CodeCard;
